/**
 * @generated SignedSource<<8096b147ed24f7f04c7692eb1a042852>>
 * @relayHash 9f5daf267ba841ca3405893d93917ec1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d08279cf4aa6afaf958ccfad90eb70e8d991ce775fa4f30b704b598c14cdca2c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HeaderControlPanelContentQuery } from './HeaderControlPanelContentQuery.graphql';

const node: PreloadableConcreteRequest<HeaderControlPanelContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d08279cf4aa6afaf958ccfad90eb70e8d991ce775fa4f30b704b598c14cdca2c",
    "metadata": {},
    "name": "HeaderControlPanelContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
